import { useEffect } from 'react';
import Loading from './Loading';
import Progress from './Progress';
import { useAppSelector, useAppDispatch } from '../../../hooks';
import { usePortal } from '../../../hooks/useNavConfig';
import { fetchOnboardingProgress } from '../../../reducers/OnboardingProgress';
import { captureException } from '../../../utils/sentryAPI';
import usePLPOData from '../../../hooks/usePLPOData';
import { withErrorBoundary } from '../../ErrorBoundary';
import memoWithDisplayName from '../../../utils/memoWithDisplayName';
import { jsx as _jsx } from "react/jsx-runtime";
const _OnboardingProgress = ({
  isEnrolledInOnboarding
}) => {
  const dispatch = useAppDispatch();
  const {
    isFetchingOnboardingProgress,
    hasError,
    progress,
    selectedView,
    groupKey
  } = useAppSelector(state => state.onboardingProgress);
  const {
    portalId
  } = usePortal();
  const {
    isEligible: isPlpoEligible,
    groupKey: plpoGroupKey,
    progress: plpoProgress,
    isFetching: isFetchingPLPO,
    hasError: hasPlpoError
  } = usePLPOData();
  useEffect(() => {
    // don't fetch onboarding progress from setup guide or growth plans if PLPO is eligible or fetching
    if (isPlpoEligible || isFetchingPLPO) {
      return;
    }
    if (portalId && !hasError && !isFetchingOnboardingProgress && !groupKey) {
      dispatch(fetchOnboardingProgress(portalId)).catch(captureException);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPlpoEligible, isFetchingPLPO]);
  if (!isEnrolledInOnboarding && !isPlpoEligible) {
    return null;
  }
  if (isFetchingOnboardingProgress || isFetchingPLPO) {
    return /*#__PURE__*/_jsx(Loading, {});
  }
  if (hasError || hasPlpoError) {
    return null;
  }
  if (isPlpoEligible && !plpoGroupKey) {
    return null;
  }
  return /*#__PURE__*/_jsx(Progress, {
    progress: progress,
    selectedView: selectedView,
    groupKey: groupKey,
    isPlpoEligible: isPlpoEligible,
    plpoGroupKey: plpoGroupKey,
    plpoProgress: plpoProgress
  });
};
export const OnboardingProgress = withErrorBoundary(memoWithDisplayName('OnboardingProgress', _OnboardingProgress), {
  boundaryName: 'OnboardingProgress'
});